<!-- Copyright (c) 2020-2022 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div>
    <div class="px-4 py-2 card-header">
      <BRow>
        <BCol
          v-show="!relationshipArrayProperty.readOnly && !!relationshipArrayProperty && relationshipArrayProperty.key==='roles' && relationshipArrayProperty.items.reversePropertyName !=='companies' && relationshipArrayProperty.items.reversePropertyName !=='engineModels'"
          class="my-1">
          <BButton 
            variant="primary"
            class="mr-1"
            @click="viewRoleStatus"
            :id="'View_role_status_' + relationshipArrayProperty.key">
            <FrIcon
              class="mr-2"
              :outlined="false"
              name="details"
            />
            View Role Status
          </BButton>
          </BCol>
          <BCol
          v-show="!relationshipArrayProperty.readOnly && !!relationshipArrayProperty && relationshipArrayProperty.key==='engineModels'"
          class="my-1">
          <BButton 
            variant="primary"
            class="mr-1"
            @click="viewEngineModelStatus"
            :id="'View_Engine_Model_status_' + relationshipArrayProperty.key">
            <FrIcon
              class="mr-2"
              :outlined="false"
              name="details"
            />
            View Engine Model Status
          </BButton>
          </BCol>
        <BCol
          v-show="!relationshipArrayProperty.readOnly || isOpenidmAdmin "
          class="my-1">
          <BButton v-show=" relationshipArrayProperty.items.reversePropertyName ==='companies' || (!!relationshipArrayProperty && relationshipArrayProperty.key !=='members' && relationshipArrayProperty.key !=='roles') || (!relationshipArrayProperty.readOnly && !!relationshipArrayProperty && isOpenidmAdmin && relationshipArrayProperty.key =='roles' && !realmIsEA)"
            variant="primary"
            class="mr-1"
            @click="openCreateModal"
            :id="'add_' + relationshipArrayProperty.key">
            <FrIcon
              class="mr-2"
              :outlined="false"
              name="add"
            />
            {{ $t("common.addObject", {object: getTranslation(relationshipArrayProperty.title)}) }}
          </BButton>
          <BButton v-show="!!relationshipArrayProperty && relationshipArrayProperty.key==='members' && relationshipArrayProperty.items.reversePropertyName ==='memberOfOrg'"
            variant="primary"
            class="mr-1"
            @click="openInviteUser"
            :id="'invite_' + relationshipArrayProperty.key">
            <FrIcon
              class="mr-2"
              :outlined="false"
              name="add"
            />
           Invite Users
          </BButton>
          <BButton
            v-show="selected.length > 0"
            variant="outline-primary"
            @click="$refs[removeModalId].show()"
            :id="'delete_' + relationshipArrayProperty.key">
            {{ $t("common.remove") }}
          </BButton>
        </BCol>
        <FrSearchInput
          v-if="showFilter && !disableSortAndSearch"
          v-model="filter"
          :placeholder="$t('common.search')"
          @clear="clear"
          @search="search" />
      </BRow>
    </div>

    <BTable
      hover
      ref="relationshipArrayGrid"
      responsive
      show-empty
      stacked="lg"
      :fields="columns"
      :items="gridData"
      :per-page="0"
      :no-local-sorting="true"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      class="mb-0"
      :selectable="!relationshipArrayProperty.readOnly || isOpenidmAdmin"
      selected-variant="transparent"
      @row-clicked="resourceClicked"
      @row-selected="onRowSelected"
      @sort-changed="sortingChanged">
      <template v-slot:head(selected)>
        <div
          v-show="gridData.length > 0"
          class="cursor-pointer"
          @click="toggleSelectAll">
          <BFormCheckbox
            class="pl-3"
            disabled
            v-model="allRowsSelected">
            <span class="sr-only">
              {{ $t('common.select') }}
            </span>
          </BFormCheckbox>
        </div>
      </template>
      <template v-slot:cell(selected)="data">
        <BFormCheckbox
          class="pl-3"
          :id="'rowSelectCheckbox_' + relationshipArrayProperty.key + data.index"
          @change="onCheckboxClicked(data)"
          v-model="data.rowSelected">
          <span class="sr-only">
            {{ $t('common.selectSelection', { selection: data.item.name ? data.item.name: data.item._relationshipDetails.join(' ') }) }}
          </span>
        </BFormCheckbox>
      </template>
      <template v-slot:cell(_relationshipDetails)="data">
        <div
          class="media cursor-pointer"
          @click="resourceClicked(data.item)">
          <div class="media-body">
            <div class="text-bold">
              {{ data.value[0] }}
            </div>
            <div>
              <span
                v-for="(display, index) in data.value"
                :key="`displayField_${display}_${index}`"
                v-show="index !== 0"
                class="pr-1 text-muted">
                {{ display }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </BTable>
    <BPagination
      v-if="gridData.length && gridData.length === gridPageSize || currentPage > 0"
      v-model="currentPage"
      class="pt-3 justify-content-center pagination-material-buttons border-top"
      last-class="d-none"
      :next-class="{'show-ellipsis': !lastPage}"
      :page-class="{'hide-last-number': !lastPage}"
      per-page="10"
      :total-rows="totalRows"
      @input="loadGrid(currentPage)" />

    <BModal
      cancel-variant="link"
      :id="createModalId"
      :ok-disabled="newRelationships.length === 0"
      :ok-title="$t('common.save')"
      :ref="createModalId"
      :title="'Add ' + relationshipArrayProperty.title"
      size="lg"
      @ok="saveNewRelationships">
      <FrRelationshipEdit
        :parent-resource="parentResource"
        :relationship-property="relationshipArrayProperty"
        :index="0"
        @setValue="addNewRelationship" />
    </BModal>

    <BModal
      cancel-variant="link"
      :id="'view_Role_status'"
      :ok-only="true"
      :ref="'view_Role_status'"
      :title="'View ' + relationshipArrayProperty.title + ' Status'"
      size="lg">
      <FRRelationshipView
        :parent-id=parentId      
      ></FRRelationshipView>
    </BModal>

    <BModal
      cancel-variant="link"
      :id="'view_Engine_Model_status'"
      :ok-only="true"
      :ref="'view_Engine_Model_status'"
      :title="'View ' + relationshipArrayProperty.title + ' Status'"
      size="lg">
      <FRRelationshipViewEngineModel
        :parent-id=parentId      
      ></FRRelationshipViewEngineModel>
    </BModal>

    <BModal
      :id="removeModalId"
      :ref="removeModalId"
      :title="$t('pages.access.removeModalTitle')">
      <div>
        {{ $t('pages.access.removeConfirm') }} {{ relationshipArrayProperty.title }}?
      </div>
      <div
        slot="modal-footer"
        class="w-100">
        <div class="float-right">
          <BButton
            variant="btn-link text-danger mr-2"
            @click="$refs[removeModalId].hide()">
            {{ $t('common.cancel') }}
          </BButton>
          <BButton
            variant="danger"
            @click="removeRelationships">
            {{ $t('common.remove') }}
          </BButton>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import {
  find,
  has,
  isNull,
  last,
  toArray,
  pick,
  map,
} from 'lodash';
import {
  BRow,
  BCol,
  BButton,
  BTable,
  BFormCheckbox,
  BModal,
  BPagination,
} from 'bootstrap-vue';
import dayjs from 'dayjs';
import pluralize from 'pluralize';
import RelationshipEdit from '@forgerock/platform-shared/src/components/resource/RelationshipEdit';
import RelationshipView from '@forgerock/platform-shared/src/components/resource/ViewRelationship';
import RelationshipViewEngineModel from '@forgerock/platform-shared/src/components/resource/ViewRelationshipEnginemodel';
import NotificationMixin from '@forgerock/platform-shared/src/mixins/NotificationMixin';
import ResourceMixin from '@forgerock/platform-shared/src/mixins/ResourceMixin';
import RestMixin from '@forgerock/platform-shared/src/mixins/RestMixin';
import TranslationMixin from '@forgerock/platform-shared/src/mixins/TranslationMixin';
import FrSearchInput from '@forgerock/platform-shared/src/components/SearchInput';
import FrIcon from '@forgerock/platform-shared/src/components/Icon';
import { getSchema } from '@forgerock/platform-shared/src/api/SchemaApi';

export default {
  name: 'RelationshipArray',
  components: {
    FrRelationshipEdit: RelationshipEdit,
    FRRelationshipView: RelationshipView,
    FRRelationshipViewEngineModel: RelationshipViewEngineModel,
    BRow,
    BCol,
    BButton,
    BTable,
    BFormCheckbox,
    BModal,
    BPagination,
    FrSearchInput,
    FrIcon,
  },
  mixins: [
    NotificationMixin,
    RestMixin,
    ResourceMixin,
    TranslationMixin,
  ],
  props: {
    revision: {
      type: String,
      default: '',
    },
    parentId: {
      type: String,
      required: true,
    },
    relationshipArrayProperty: {
      type: Object,
      required: true,
    },
    parentResource: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      realmIsEA: (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? true : false,
      gridPageSize: 10,
      allRowsSelected: false,
      gridData: [],
      columns: [],
      currentPage: 1,
      sortBy: null,
      sortDesc: false,
      filter: '',
      lastPage: false,
      sortDirection: 'asc',
      createModalId: `create_${this.relationshipArrayProperty.propName}_modal`,
      removeModalId: `delete_${this.relationshipArrayProperty.propName}_modal`,
      newRelationships: [],
      selected: [],
      isOpenidmAdmin: this.$store.state.UserStore.adminUser,
      isPortalAdmin:this.$store.state.UserStore.portalAdminUser,
      showFilter: false,
      disableSortAndSearch: false,
      requiredProps: ['_ref', '_refResourceCollection', '_refResourceId', '_refProperties'],
    };
  },
  mounted() {
    this.loadGrid(1);
    console.log("===================+++++++++++++>",this.realmIsEA)
  },
  watch: {
    gridData() {
      this.columns = this.columns.map((col) => {
        if (col.key !== 'selected') {
          col.sortable = !this.disableSortAndSearch;
        }

        return col;
      });
    },
  },
  computed: {
    totalRows() {
      if (this.lastPage) {
        return this.currentPage * 10;
      }
      return this.currentPage * 10 + 1;
    },
  },
  methods: {
    openInviteUser(){
      if(this.realmIsEA){
        window.open('../../../../../EngineAlliance/inviteUser?id='+this.$route.params.resourceId);
      } else {
        window.open('../../../../../identity/inviteUser?id='+this.$route.params.resourceId);
      }
    },
    viewRoleStatus(){
      this.$refs['view_Role_status'].show();
     // this.newRelationships = [];
      //window.open('../../../../../identity/inviteUser?id='+this.$route.params.resourceId);
    },
    viewEngineModelStatus(){
      if(!this.realmIsEA){
        this.$refs['view_Engine_Model_status'].show();
      }
      
    },
    loadGrid(page) {
      this.currentPage = page;
      const doLoad = (resourceCollectionSchema) => {
        console.log(resourceCollectionSchema)
        //console.log(resourceCollectionSchema.this.relationshipArrayProperty.key.)
        console.log(this.relationshipArrayProperty.items.reversePropertyName)
        console.log(this.relationshipArrayProperty.key)
        this.getRequestService().get(this.buildGridUrl(page - 1, resourceCollectionSchema)).then((resourceData) => {
          if (resourceData.data.pagedResultsCookie) {
            this.lastPage = false;
          } else {
            this.lastPage = true;
          }

          this.gridData = [];
          this.setColumns(resourceCollectionSchema);
          this.setGridData(resourceData.data.result, this.relationshipArrayProperty);
        }).catch((error) => {
          this.showErrorMessage(error, this.$t('errors.errorRetrievingRelationships'));
        });
      };

      if (has(this.relationshipArrayProperty, 'items.resourceCollection') && this.relationshipArrayProperty.items.resourceCollection.length === 1) {
        const resourceCollection = this.relationshipArrayProperty.items.resourceCollection[0];
        this.setDisableSortAndSearch(resourceCollection);
        
        getSchema(resourceCollection.path).then((response) => {
          this.showFilter = true;
          doLoad(response.data);
        });
      } else {
        doLoad();
      }
    },
    setDisableSortAndSearch(resourceCollection) {
      const { uiConfig } = this.$store.state.SharedStore;
      const resourceType = resourceCollection.path.split('/')[0];
      let resourceName = resourceCollection.path.split('/')[1];
      // special case for internal/role
      if (resourceName === 'role' && resourceType === 'internal') {
        resourceName = 'internalrole';
      }
      const configDisableRelationshipSortAndSearch = has(uiConfig, `configuration.platformSettings.managedObjectsSettings.${resourceName}`) ? uiConfig.configuration.platformSettings.managedObjectsSettings[resourceName].disableRelationshipSortAndSearch : false;
      this.disableSortAndSearch = !this.isOpenidmAdmin && configDisableRelationshipSortAndSearch;
    },
    setColumns(resourceCollectionSchema) {
      if (!this.relationshipArrayProperty.readOnly || this.isOpenidmAdmin) {
        this.columns.push({
          key: 'selected',
          label: '',
          class: 'checkbox-column',
        });
      }

      if (resourceCollectionSchema) {
        this.relationshipArrayProperty.items.resourceCollection[0].query.fields.forEach((fieldName) => {
          this.columns.push({
            key: fieldName,
            label: this.getTranslation(resourceCollectionSchema.properties[fieldName].title || pluralize.singular(fieldName)),
            sortable: true,
            sortDirection: 'desc',
          });
        });
      } else {
        this.columns.push({
          key: '_relationshipDetails',
          label: pluralize.singular(this.relationshipArrayProperty.title),
        });
      }

      if (this.relationshipArrayProperty.relationshipGrantTemporalConstraintsEnforced) {
        this.columns.push({
          key: '_refProperties.temporalConstraints[0].duration',
          label: this.$t('pages.access.timeConstraint'),
          formatter: (value) => {
            if (value) {
              const dates = map(value.split('/'), (date) => {
                const retVal = dayjs(date).format('MMMM D, YYYY h:mm A');

                return retVal;
              });

              return `${dates[0]} to ${dates[1]}`;
            }

            return value;
          },
        });
      }
    },
    setGridData(relationships, schema) {
      const addRows = () => {
        relationships.forEach((relationship) => {
          // eslint-disable-next-line no-underscore-dangle
          const resourceCollectionSchema = find(schema.items.resourceCollection, { path: relationship._refResourceCollection });
          // special display logic for internal user
          if (resourceCollectionSchema && has(resourceCollectionSchema, 'path') && resourceCollectionSchema.path === 'internal/user') {
            // _ref looks "internal/user/openidm-admin"
            // here we are grabbing the last part of the path to display "userName" which is also the internal user's "_id"
            // eslint-disable-next-line no-underscore-dangle
            relationship._relationshipDetails = [last(relationship._ref.split('/'))];
          } else if (resourceCollectionSchema) {
            // eslint-disable-next-line no-underscore-dangle
            relationship._relationshipDetails = toArray(pick(relationship, resourceCollectionSchema.query.fields));
          } else {
            // if no schema information for resourceCollection just show the object's _id
            // eslint-disable-next-line no-underscore-dangle
            relationship._relationshipDetails = [relationship._id];
          }

          this.gridData.push(relationship);
        });
      };

      if (this.disableSortAndSearch) {
        const promises = [];
        // When we disable sort and search the list of relationships does not include the related object's data.
        // In this case to retrieve the data needed to fill in grid columns we need to loop over each relationship
        // record and do a get on the _ref ('managed/user/USER_GUUID').
        relationships.forEach((relationship, index) => {
          // eslint-disable-next-line no-underscore-dangle
          const resourceCollectionSchema = find(schema.items.resourceCollection, { path: relationship._refResourceCollection });
          promises.push(
            this.getRelationshipFieldsData(relationship, resourceCollectionSchema.query.fields).then((fieldsData) => {
              // once we get fields data merge it with the existing relationship data
              relationships[index] = { ...relationship, ...fieldsData };
            }),
          );
        });

        Promise.all(promises).then(() => {
          addRows();
        });
      } else {
        addRows();
      }
    },
    getRelationshipFieldsData(relationship, fields) {
      return this.getRequestService().get(`${relationship._ref}?_fields=${fields}`).then((response) => pick(response.data, fields));
    },
    buildGridUrl(page, resourceCollectionSchema) {
      const currentResourceCollection = find(this.relationshipArrayProperty.items.resourceCollection, { path: resourceCollectionSchema ? resourceCollectionSchema.resourceCollection : null });
      let resourceUrl = `${this.parentResource}/${this.parentId}/${this.relationshipArrayProperty.propName}?_pageSize=${this.gridPageSize}&_totalPagedResultsPolicy=ESTIMATE`;

      if (this.filter) {
        resourceUrl = `${resourceUrl}&_queryFilter=${this.generateSearch(this.filter, currentResourceCollection.query.fields, resourceCollectionSchema.properties)}`;
      } else {
        resourceUrl = `${resourceUrl}&_queryFilter=true`;
      }

      if (!this.disableSortAndSearch && currentResourceCollection) {
        resourceUrl = `${resourceUrl}&_fields=${this.requiredProps.join(',')},${currentResourceCollection.query.fields.join(',')}`;
      }

      if (page > 0) {
        const offsetCalc = (page) * this.gridPageSize;

        resourceUrl = `${resourceUrl}&_pagedResultsOffset=${offsetCalc}`;
      }

      if (this.sortBy) {
        let sortUrl = null;

        if (!isNull(this.sortBy)) {
          if (this.sortDesc) {
            sortUrl = `${this.sortBy}`;
          } else {
            sortUrl = `-${this.sortBy}`;
          }
        }
        resourceUrl = `${resourceUrl}&_sortKeys=${sortUrl}`;
      }

      return resourceUrl;
    },
    resourceClicked(item, index, event) {
      if (!event || !event.target.classList.value || event.target.classList.value.indexOf('checkbox') === -1) {
        this.$router.push({
          name: 'EditResource',
          params: {
            // eslint-disable-next-line no-underscore-dangle
            resourceType: item._refResourceCollection.split('/')[0],
            // eslint-disable-next-line no-underscore-dangle
            resourceName: item._refResourceCollection.split('/')[1],
            // eslint-disable-next-line no-underscore-dangle
            resourceId: item._refResourceId,
          },
        });
      }
    },
    openCreateModal() {
      if (this.relationshipArrayProperty.key==='roles' && this.relationshipArrayProperty.items.reversePropertyName !=='companies' && this.relationshipArrayProperty.items.reversePropertyName !=='engineModels' && this.isOpenidmAdmin) {
        if(this.realmIsEA){
        window.open('../../../../../EngineAlliance/roleRequest?tab=requestRoles&userId='+this.$route.params.resourceId);
      } else {
        window.open('../../../../../identity/roleRequest?tab=requestRoles&userId='+this.$route.params.resourceId);
      }
        return;
       }
      this.$refs[this.createModalId].show();
      this.newRelationships = [];
      
    },
    addNewRelationship(data) {
      if (data) {
        this.newRelationships = data;
      }
    },
    onCheckboxClicked(row) {
      if (row.rowSelected) {
        this.$refs.relationshipArrayGrid.selectRow(row.index);
      } else {
        this.$refs.relationshipArrayGrid.unselectRow(row.index);
      }
    },
    onRowSelected(items) {
      this.selected = items;

      this.allRowsSelected = items.length === Math.min(this.gridData.length, this.gridPageSize);
    },
    toggleSelectAll() {
      const grid = this.$refs.relationshipArrayGrid;

      if (!this.allRowsSelected) {
        grid.selectAllRows();
      } else {
        grid.clearSelected();
      }
    },
    saveNewRelationships() {
      this.updateRelationship('add', this.newRelationships);
    },
    removeRelationships() {
      const relationshipsToRemove = [];

      this.selected.forEach((relationship) => {
        if (relationship) {
          relationshipsToRemove.push(pick(relationship, this.requiredProps));
        }
      });

      this.updateRelationship('remove', relationshipsToRemove);
    },
    updateRelationship(operation, items) {
      const patchArray = map(items, (item) => {
        if (operation === 'remove') {
          return {
            operation: 'remove',
            field: `/${this.relationshipArrayProperty.propName}`,
            value: item,
          };
        }
        return {
          operation: 'add',
          field: `/${this.relationshipArrayProperty.propName}/-`,
          value: item,
        };
      });
      const loadAndCloseModal = () => {
        const modal = operation === 'remove' ? this.removeModalId : this.createModalId;
        this.loadGrid(1);
        this.$refs[modal].hide();
      };

      this.getRequestService({
        headers: {
          'if-match': this.revision,
        },
      }).patch(`${this.parentResource}/${this.parentId}`, patchArray).then(() => {
        const translation = operation === 'remove' ? 'pages.access.successRemoved' : 'pages.access.successAdded';
        loadAndCloseModal();
        this.displayNotification('IDMMessages', 'success', this.$t(translation, { resource: this.relationshipArrayProperty.title }));
        this.$emit('refresh-data');
      }).catch((error) => {
        loadAndCloseModal();
        this.showErrorMessage(error, this.$t('errors.errorRetrievingRelationships'));
      });
    },
    /**
     * Repulls data based on new sort, and returns table to first page
     *
     * @param {object} sort - Required object containing sort metadata
     */
    sortingChanged(sort) {
      this.sortBy = sort.sortBy;
      this.sortDesc = sort.sortDesc;

      this.loadGrid(1);
    },
    /**
     * Reloads data after search box filter text is cleared
     */
    clear() {
      this.filter = '';
      this.sortBy = null;
      this.sortDesc = false;

      this.loadGrid(1);
    },
    /**
     * Repulls data based on input search box text
     */
    search() {
      if (this.filter === '') {
        this.clear();
        return;
      }
      this.sortBy = null;
      this.sortDesc = false;

      this.loadGrid(1);
    },
  },
};
</script>

<style lang="scss" scoped>
    ::v-deep {
      .fr-resource-paginator {
        a[role='menuitemradio'] {
          display: none !important;
        }
      }

      .checkbox-column {
        width: 15px;
        padding-right: 0;
        vertical-align: middle;
      }

      .cursor-pointer {
        cursor: pointer;
      }

      .modal-body {
        overflow: visible;
      }
    }
</style>
